"use client";

import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinTheScene() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="4263" id="join-the-scene" className="bg-background text-foreground relative overflow-hidden py-32 md:py-48 lg:py-[200px] px-6">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.08]">
        <svg viewBox="0 0 800 400" className="w-[120%] max-w-none" fill="none" stroke="currentColor" strokeWidth="0.5">
          <path d="M0,200 L800,200 M400,0 L400,400" />
          <path d="M100,100 L700,300 M100,300 L700,100" />
          <circle cx="400" cy="200" r="120" strokeDasharray="4 4" />
          <circle cx="400" cy="200" r="160" strokeDasharray="8 8" />
          <path d="M350,150 L450,250 M350,250 L450,150" strokeWidth="2" />
          <rect x="380" y="180" width="40" height="40" strokeWidth="1" />
        </svg>
      </div>

      <div ref={ref} className={`relative mx-auto max-w-[780px] text-center transition-all duration-600 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="flex items-center justify-center gap-3" aria-hidden="true">
          <span className="block h-px w-[80px] bg-primary" />
        </div>
        <div className="mt-3 flex items-center justify-center" aria-hidden="true">
          <svg viewBox="0 0 24 24" className="h-4 w-4 text-primary" fill="currentColor">
            <path d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z" />
          </svg>
        </div>
        <div className="mt-3 flex items-center justify-center gap-3" aria-hidden="true">
          <span className="block h-px w-[80px] bg-primary" />
        </div>

        {}
        <p className="mt-12 font-mono text-[11px] tracking-[0.2em] uppercase text-primary">
          SESSION_04 &mdash; LIVE TRACKING & REHEARSAL
        </p>

        {}
        <h2 className="font-default mt-8 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold uppercase tracking-tighter leading-[0.9] text-foreground">
          Plug in and
          <br />
          <span className="text-primary">crank the master volume.</span>
        </h2>

        {}
        <p className="font-default mx-auto mt-10 max-w-[640px] text-lg md:text-[19px] leading-relaxed text-foreground/90">
          Whether you're tracking a live EP or prepping for a sold-out tour, The Garage Room 
          provides the backline, the grit, and the community to make it loud. 
          Check our availability and claim your slot in the noise.
        </p>

        {}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10">
          <Link to="/BookPage" className="group relative inline-block">
            <Button size="lg" className="font-mono text-sm font-bold tracking-[0.1em] uppercase bg-primary text-primary-foreground hover:translate-x-1 hover:translate-y-1 transition-transform duration-0 px-8 h-14 rounded-md shadow-md">
              Download Calendar
            </Button>
            <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 block h-px w-12 bg-primary transition-all duration-300 group-hover:w-20" />
          </Link>

          <Link to="tel:+15550000000" className="font-default text-base md:text-lg text-foreground/90 hover:text-primary transition-colors inline-flex items-center gap-2 border-b border-border hover:border-primary pb-1">
            <Phone className="h-4 w-4" aria-hidden="true" />
            <span className="font-semibold">or call the studio +1 (555) 000-0000</span>
          </Link>
        </div>

        {}
        <p className="mt-16 font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
          24/7 Access &middot; Industrial District, East Side
        </p>
      </div>
    </section>;
}